/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetQuickbooksAccessTokenRequest } from '../models/GetQuickbooksAccessTokenRequest';
import type { QuickbooksCSRFTokenRequest } from '../models/QuickbooksCSRFTokenRequest';
import type { RevokeQuickbooksAuthorizationTokenResponse } from '../models/RevokeQuickbooksAuthorizationTokenResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class QuickbooksService {

    /**
     * Revokes the Zendesk access token on behalf of an user.
     * @param organizationId The ID of the organization to scope the integrations for.
     * @returns RevokeQuickbooksAuthorizationTokenResponse OK
     * @throws ApiError
     */
    public static revokeQuickbooksAuthorizationToken(
        organizationId: string,
    ): CancelablePromise<RevokeQuickbooksAuthorizationTokenResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/integrations/organizations/{organizationId}/quickbooks/revokeAuthToken',
            path: {
                'organizationId': organizationId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static storeQuickbooksCsrfToken(
        requestBody?: QuickbooksCSRFTokenRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/integrations/quickbooks/storeQuickbooksCSRFToken',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Gets the access token for the Zendesk integration.
     * @param requestBody The request
     * @returns string OK
     * @throws ApiError
     */
    public static quickbooksCallBackAuthentication(
        requestBody?: GetQuickbooksAccessTokenRequest,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/integrations/quickbooks/getAccessToken',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

}
